
import { defineComponent, SetupContext, PropType } from "vue";
import CommonRecipeFoodIdItem from "@/components/commonRecipe/CommonRecipeFoodIdItem.vue";
import { CommonRecipeFoodId } from "@/types/commonRecipe";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "CommonRecipeFoodIds",
  components: { CommonRecipeFoodIdItem },
  props: {
    /**
     * タグを表示するデータ配列
     */
    foodIds: {
      type: Array as PropType<CommonRecipeFoodId[]>,
      default: () => []
    }
  },
  setup(_, context: SetupContext) {

    /**
     * タグリストを取得する
     */
    const getFoodIds = (foodIds: CommonRecipeFoodId[]) => {
      foodIds.forEach(e => {
        NativeClient.sendDebugLog("CommonRecipeFoodIds getFoodIds foodId = " + e.id);
      });
      if (foodIds != null) {
        return foodIds;
      } else {
        return null;
      }
    };

    return {
      getFoodIds
    };
  }
});
